/**
 * Create a custom overlay for our window marker display, extending google.maps.OverlayView.
 * This is somewhat complicated by needing to async load the google.maps api first - thus, we
 * wrap customInfoWindow into a closure, and when instantiating CustomNativeWindow, we first execute the closure
 * (to create our CustomNativeWindow function, now properly extending the newly loaded google.maps.OverlayView),
 * and then instantiate said function.
 * @type {Function}
 * @see _mapView.onRender
 * From: https://artandlogic.com/2014/02/custom-google-maps-info-windows/
 */

var customInfoWindow = function() {
  this.container = document.createElement('div');
  this.container.classList.add('map-info-window');
  this.layer = null;
  this.marker = null;
  this.position = null;
};
/**
 * Inherit from OverlayView
 * @type {google.maps.OverlayView}
 */
customInfoWindow.prototype = new window.google.maps.OverlayView();
/**
 * Called when this overlay is set to a map via this.setMap. Get the appropriate map pane
 * to add the window to, append the container, bind to close element.
 * @see customInfoWindow.open
 */
customInfoWindow.prototype.onAdd = function() {
  this.layer = this.getPanes().floatPane;
  this.layer.appendChild(this.container);
  if (this.container.querySelector('.infowindow-close')) {
    this.container.querySelector('.infowindow-close').addEventListener(
      'click',
      function() {
        // Close info window on click
        this.close();
      }.bind(this),
      false
    );
  }
};
/**
 * Called after onAdd, and every time the map is moved, zoomed, or anything else that
 * would effect positions, to redraw this overlay.
 */
customInfoWindow.prototype.draw = function() {
  this.container.style.position = 'relative';
  this.container.style.display = 'inline-block';
  var markerIcon = this.marker.getIcon();
  var cBounds = this.container.getBoundingClientRect();
  var cHeight = cBounds.height + markerIcon.scaledSize.height / 2 + 10;
  var cWidth = cBounds.width / 2;
  this.position = this.getProjection().fromLatLngToDivPixel(
    this.marker.getPosition()
  );
  this.container.style.top = this.position.y - cHeight + 'px';
  this.container.style.left = this.position.x - cWidth + 'px';
};
/**
 * Called when this overlay has its map set to null.
 * @see customInfoWindow.close
 */
customInfoWindow.prototype.onRemove = function() {
  this.layer.removeChild(this.container);
};
/**
 * Sets the contents of this overlay.
 * @param {string} html
 */
customInfoWindow.prototype.setContent = function(html) {
  this.container.innerHTML = html;
};
/**
 * Sets the map and relevant marker for this overlay.
 * @param {google.maps.Map} map
 * @param {google.maps.Marker} marker
 */
customInfoWindow.prototype.open = function(map, marker) {
  this.marker = marker;
  this.setMap(map);
};
/**
 * Close this overlay by setting its map to null.
 */
customInfoWindow.prototype.close = function() {
  this.setMap(null);
};

export default customInfoWindow;



// WEBPACK FOOTER //
// ./src/components/custom-map-marker.js